import RippleInk from '../ripple-ink.vue'

export default {
	components: {
		RippleInk
	}
}
